export enum ZIndexes {
  Content = 1,
  AboveContent = 2,
  Loader = 8,
  Tooltips = 9,
  Menus = 10,
  AppBanner = 11,
  Overlay = 100,
  Navigation = 200,
  Panel = 300,
  Modal = 400,
  Top = 500,
}
